import React from 'react'

const NotificationSms = () => {
  return (
    <div>NotificationSms</div>
  )
}

export default NotificationSms